import { useCallback, useMemo } from "react";
import { Form as BForm, Card, Col, Row } from "react-bootstrap";
import { Field } from "formik";
import CustomPicker from "./CustomPicker";
import TextInput from "../../../../../components/formfields/InputField";
import SubmitLoader from "../../../../../components/SubmitLoader";

type FreeBiesPropsTypes = {
  section?: string;
  values?: any;
  props?: any;
  handleChange?: any;
  handleBlur?: any;
  setFieldValue?: any;
  sectionEdit?: boolean;
  uploadFileNewAction?: any;
};

const Freebies = ({ section, props, values, handleChange, handleBlur, setFieldValue, sectionEdit, uploadFileNewAction }: FreeBiesPropsTypes) => {
  const count = useMemo(() => {
    if (section === "freebies1") return "1";
    if (section === "freebies2") return "2";
    return "3";
  }, [section]);

  // const handleUpload = (event: any, fieldValue: any, name: string) => {
  //   const data = {
  //     file: event.currentTarget.files[0],
  //   };
  //   props.uploadFileAction(data, fieldValue, name);
  // };

  const handleUpload = (event: any, fieldValue: any, name: string, oldImage: any) => {
    const formData = new FormData();
    formData.append("file", event.currentTarget.files[0]);
    formData.append("folder", "home-page");
    formData.append("url", oldImage ? oldImage : "");
    uploadFileNewAction(formData, fieldValue, name);
  };

  const onImageChange = useCallback((event: any, fieldValue: any, name: string, dummyImage: string, oldImage?: any) => {
    if (event.target.files?.[0]) {
      const file = event.target.files[0];
      handleUpload(event, fieldValue, name, oldImage);
      const URL = window.URL || window.webkitURL;
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      img.src = objectUrl;
      img.onload = function handleImageLoad() {
        // fieldValue(name, event.target.files[0]);
        const reader = new FileReader();
        reader.onload = (e) => {
          fieldValue(dummyImage, e?.target?.result);
        };
        reader.readAsDataURL(event.target.files[0]);
      };
    }
  }, []);

  const handleRemove = useCallback((field: string, dummyImage: string, fieldValue: any) => {
    fieldValue(field, "");
    fieldValue(dummyImage, "");
  }, []);

  return (
    <Card>
      <Card.Header className="d-flex justify-content-between align-items-center">
        <h6 className="mb-0 fs-lg }">Freebies {count}</h6>
      </Card.Header>
      <Card.Body>
        <Row className="gy-3 align-items-end">
          <Col xs={12}>
            <CustomPicker
              setFieldValue={setFieldValue}
              name={`${section}.numberColor`}
              value={values[`${section}`].numberColor}
              label="Number Color"
              edit={sectionEdit}
            />
          </Col>
          <Col sm={8}>
            <BForm.Label>Title</BForm.Label>
            <Field
              name={`${section}.title`}
              component={TextInput}
              value={values[section as keyof typeof values]?.title}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Title"
              readOnly={!sectionEdit}
              className={sectionEdit ? "editField" : ""}
            />
          </Col>
          <Col sm={4}>
            <CustomPicker
              setFieldValue={setFieldValue}
              name={`${section}.hoverColor`}
              value={values[`${section}`].hoverColor}
              label="Hover Color"
              edit={sectionEdit}
            />
          </Col>
          <Col sm={12}>
            <label className="form-label">Link</label>
            <Field
              name={`${section}.link`}
              component={TextInput}
              value={values[section as keyof typeof values]?.link}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Link"
              readOnly={!sectionEdit}
              className={sectionEdit ? "editField" : ""}
            />
          </Col>
          <Col xs="12">
            <label className="form-label d-block">Upload Image</label>
            {values[`${section}`].dummyImage || values[`${section}`].image ? (
              <>
                <div style={{ maxWidth: "200px" }}>
                  <div className="uploarForm square position-relative overflow-hidden">
                    {values[`${section}`].image ? (
                      <>
                        {sectionEdit && (
                          <button
                            className="btn btn-danger btn-sm btn-icon position-absolute top-0 end-0 rounded me-2 mt-2 zindex-1"
                            onClick={() => {
                              setFieldValue(`${section}.oldImage`, values[`${section}`].image);
                              handleRemove(`${section}.image`, `${section}.dummyImage`, setFieldValue);
                            }}
                          >
                            <i className="fa-regular fa-trash-can"></i>
                          </button>
                        )}
                        {!values[`${section}`].image?.includes("/storage") && !values[`${section}`].dummyImage ? (
                          <div className="position-absolute top-50 text-center w-100 translate-middle-y">
                            <SubmitLoader />
                          </div>
                        ) : (
                          <img className="img-fluid position-absolute" src={values[`${section}`].dummyImage || values[`${section}`].image} alt="imagessss" />
                        )}
                      </>
                    ) : (
                      <div className="position-absolute top-50 text-center w-100 translate-middle-y">
                        <SubmitLoader />
                      </div>
                    )}
                  </div>
                </div>
              </>
            ) : (
              <div className="uploarForm position-relative nr-height">
                <i className="fa-light fa-upload fa-2x text-primary"></i>
                <h6 className="mb-0 mt-3">Upload Images</h6>
                <input
                  id="file"
                  name="image"
                  type="file"
                  accept="image/x-png,image/gif,image/jpeg"
                  onChange={(e) => onImageChange(e, setFieldValue, `${section}.image`, `${section}.dummyImage`, values[`${section}`].oldImage)}
                  disabled={!sectionEdit}
                />
              </div>
            )}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default Freebies;
